import { useState } from "react";
import { InputField, MainButton, Loader } from "commonUI";
import "./auth.css";
import { Logo } from "allIcons";
import { printError, useSearch, useUtilities } from "helpers";
import { ApiResponseType } from "enums";
import axios from "axios";
import { t } from "i18next";

export default function CreatePassword() {
  const { navigate, notification } = useUtilities();
  const { rt, id } = useSearch();
  const [userInput, setUserInput] = useState({
    password: "",
    confirm_password: "",
    error: "",
    sucess: "",
  });
  const [loading, setLoading] = useState(false);

  function handleForget(e) {
    e.preventDefault();
    setLoading(true);
    if (!userInput.password) {
      setUserInput({
        ...userInput,
        error: t("createPassword.input.error.enterPassword"),
        sucess: "",
      });
      setLoading(false);
      return;
    }
    if (userInput.password !== userInput.confirm_password) {
      setUserInput({
        ...userInput,
        error:
          t("resetPassword.input.error.passwordsDoNotMatch"),
        sucess: "",
      });
      setLoading(false);
      return;
    }
    if (userInput.password.length < 8) {
      setUserInput({
        ...userInput,
        error: t("resetPassword.input.error.minimumLenghthRequired"),
        sucess: "",
      });
      setLoading(false);
      return;
    }
    if (userInput.password.length > 30) {
      setUserInput({
        ...userInput,
        error: t("resetPassword.input.error.maximumLenghthExceeded"),
        sucess: "",
      });
      setLoading(false);
      return;
    }
    if (!userInput.confirm_password) {
      setUserInput({
        ...userInput,
        error: t("createPassword.input.error.enterConfirmPassword"),
        sucess: "",
      });
      setLoading(false);
      return;
    }
    if (
      !userInput.password.match(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#-_^])[A-Za-z\d@$!%*?&#-_^]{8,40}$/
      )
    ) {
      setUserInput({
        ...userInput,
        error: t("resetPassword.input.error.passwordsMustMatchPattern"),
        sucess: "",
      });
      setLoading(false);
      return;
    }
    if (!Number(id) || isNaN(Number(id))) {
      setUserInput({
        ...userInput,
        error: t("createPassword.api.error.sessionExpired"),
        sucess: "",
      });
      setLoading(false);
      return;
    }
    axios
      .post(`${process.env.REACT_APP_API_URL}creatememberpassword`, {
        password: userInput.password,
        id: Number(id),
        rt,
      })
      .then((res) => res.data)
      .then((data) => {
        if (data.status_code === ApiResponseType.SUCCESS) {
          setUserInput({
            ...userInput,
            sucess: t("createPassword.api.success.passwordCreated"),
            error: "",
          });
          notification({
            message: t("createPassword.api.success.passwordCreated"),
            type: "success",
          });
          navigate("/login");
        } else {
          setUserInput({
            ...userInput,
            error: t("createPassword.api.error.sessionExpired"),
            sucess: "",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setUserInput({
          ...userInput,
          error: printError(err.message),
          sucess: "",
        });
        setLoading(false);
      });
  }
  return (
    <>
      <Loader show={loading} />
      <div className={`login-container`}>
        <div className="">
          <div
            className={`flex items-center bg-transparent mb-[87px] justify-center`}
          >
            <Logo className="logo-size" />
          </div>
          <div className="login-form">
            <h2 className="login-heading">{t("createPassword.title")}</h2>
            <div className="py-4 w-fit mx-auto max-w-25rem">
              {userInput.error ? (
                <p className="error-text mb-1 mt-0">{userInput.error}</p>
              ) : (
                userInput.sucess && (
                  <p className="success-text mb-1 mt-0">{userInput.sucess}</p>
                )
              )}
              <InputField
                type="password"
                name="password"
                id="password"
                placeholder={t("resetPassword.input.password.placeholder")}
                value={userInput.password}
                setValue={(value) =>
                  setUserInput({ ...userInput, password: value })
                }
                inputClass="py-1"
              />
              <InputField
                type="password"
                name="confirm_password"
                id="confirm_password"
                placeholder={t("resetPassword.input.confirmPassword.placeholder")}
                value={userInput.confirm_password}
                setValue={(value) =>
                  setUserInput({ ...userInput, confirm_password: value })
                }
                inputClass="py-1"
              />
              <div className="py-2">
                <MainButton onClick={handleForget} className={`w-full py-2 `}>
                  {t("createPassword.button.create")}
                </MainButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
